export const STAFF_OR_FACILITY_HAS_NO_AVAILABLE_SLOTS_ERROR_CODES: string[] = [
  "APPOINTMENT_FACILITY_UNAVAILABLE",
  "APPOINTMENT_STAFF_UNAVAILABLE",
  "EVENT_OCCURRENCE_STAFF_UNAVAILABLE",
  "EVENT_OCCURRENCE_FACILITY_UNAVAILABLE",
];
